import React from 'react';
import './WhereWeWork.css';
import rewardImage from '../images/new_group_project2.jpg'; // You'll need to add this image

const Reward: React.FC = () => {
  const partnershipDetails = [
    {
      title: 'Partnership Announcement',
      description: 'WCLRF and the REWARD Project collaboration for Afghan civil society empowerment.',
      icon: 'fas fa-handshake'
    }
  ];

  return (
    <div className="where-we-work-page">

      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>WCLRF and the REWARD Project</h2>
            <p>Strengthening Afghan civil society through empowerment, resilience, and development</p>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={rewardImage} 
              alt="WCLRF and REWARD Partnership" 
              className="clean-afghanistan-map"
            />
          </div>
        </div>
      </section>

      {/* Partnership Details Section */}
      <section className="scope-work-section">
        <div className="container">
          <div className="scope-cards-grid">
            {partnershipDetails.map((item, index) => (
              <div key={index} className="scope-card">
                <div className="scope-card-header">
                  <i className={item.icon}></i>
                  <h3><strong>Strategic Partnership Announcement</strong></h3>
                </div>
                <p className="scope-card-description">
                  We are pleased to announce a significant new partnership with the Women and Children Legal Research Foundation (WCLRF). Together, we have embarked on a collaborative project aimed at strengthening Afghan civil society through the <strong>"Empowerment and Resilience of Communities through Welfare, Rights Assessment, and Development" (REWARD)</strong> initiative.
                  <br/><br/>

                  <strong><h3>Objective of the Partnership</h3></strong>
                  <br/>
                  The core objective of this Memorandum of Understanding (MoU) is to establish enhanced coordination with key domestic institutions. This collaboration will streamline and align various programs under the REWARD project's framework.
                  <br/><br/>
                  Through this initiative, <strong>15 selected institutions</strong> will undergo a comprehensive capacity assessment. Based on the findings, a tailored Strategic Capacity-Building Plan will be developed for each. The ultimate goal is to empower these institutions, enabling them to:
                  <br/><br/>
                  <strong>1. Deliver higher-quality services</strong> to Afghan communities.
                  <br/><br/>
                  <strong>2. Implement their activities</strong> more effectively and efficiently.
                  <br/><br/>
                  <strong>3. Expand their operational scope</strong> to contribute more significantly to Afghanistan's development and progress.
                  <br/><br/>

                  <strong><h3>Agreement Timeline</h3></strong>
                  <br/>
                  This partnership is formally effective from <strong>the last quarter of 2025 through December 2030</strong>. To ensure the collaboration remains dynamic and responsive, the MoU will be subject to an annual review. This evaluation will consider evolving conditions, developments, and the mutual cooperation experience, allowing for revisions if necessary. If no amendments are required, the agreement will remain in full force for the entire duration.
                  <br/><br/>

                  <strong><h3>Role of WCLRF</h3></strong>
                  <br/>
                  As our key partner in this endeavor, WCLRF will lead the capacity-building component with the following responsibilities:
                  <br/><br/>
                  <strong>1. Conducting organizational capacity assessments</strong> for selected institutions.
                  <br/><br/>
                  <strong>2. Developing strategic, tailored capacity-building plans</strong> based on assessment findings.
                  <br/><br/>
                  <strong>3. Implementing capacity-building activities</strong> for institutions within the REWARD project framework.
                  <br/><br/>
                  <strong>4. Developing and updating 15 key policies and an organizational strategy</strong> for each institution by 2030.
                  <br/><br/>
                  <strong>5. Providing technical cooperation</strong> in proposal writing, policy implementation, and communications to strengthen institutional capacity.
                  <br/><br/>
                  <strong>6. Annually updating the institutional assessment checklist</strong> based on progress and the operational capacity-building plan.
                  <br/><br/>

                  <strong>Our Vision for Impact</strong>
                  <br/><br/>
                  We are excited about the potential of this partnership with WCLRF to create lasting, positive change. By building the foundation of strong, capable local institutions, the REWARD project moves closer to its mission of fostering empowered, resilient, and thriving communities across Afghanistan.
                  <br/><br/>
                  This partnership represents more than just a collaboration—it's a commitment to sustainable development through institutional strengthening, community empowerment, and strategic capacity building. Together, we aim to create systems that will continue to benefit Afghan communities long after the project's conclusion.
                  <br/><br/>

                  <strong>A Call for Collaboration</strong>
                  <br/><br/>
                  We invite other organizations, donors, and stakeholders to join us in this transformative journey. Your support and partnership can amplify our impact and help us reach more communities across Afghanistan. Together, we can build a future where Afghan civil society organizations are equipped, empowered, and ready to lead their communities toward sustainable development and prosperity.
                  <br/><br/>
                  <strong>Join us in making the REWARD project a cornerstone of Afghanistan's development journey.</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Reward;